// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2a0a7a6d] .el-rate {\n  min-height: 0.2rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
